/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";

const Banner = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-img">
      <div className="p-relative w-100">
        <div className="overlaybanner">
          <div className="container">
            <div
              className="banner-head"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "11px",
                marginTop: "6rem",
                positiona: "absolute",
              }}
            >
              {/* <h2
                style={{
                  zIndex: "1",
                  position: "relative",
                  textAlign: "center",
              
                  fontSize: "44px",
                  color: "white",
                  width:"80%",
                  margin:"0 auto",
                  fontWeight: "600",
                  letterSpacing: "-1px",
                }}
                className="mb-h"
              >
          Our Mission
              </h2> */}

              <p
                className="mb-p"
                style={{
                  zIndex: "1",
                  position: "relative",
                  textAlign: "center",
                  fontSize: "20px",
                  color: "white",
                  maxWidth: "70%",
                  margin: "0 auto",
                }}
              >
                Want to make smart choices when picking a Forex broker? Our
                expert financial assessments can help you out! Our Forex Broker
                Directory is always up-to-date with the latest info. When it
                comes to your money, we strongly recommend choosing brokers that
                are regulated. Stay safe and make informed decisions!
                {/* <span style={{ fontWeight: "500" }}>
                  {" "}
                  We Always Recommend Open Account With Well-Regulated Brokers
                  And Avoid Unregulated Brokers At All Cost.
                </span> */}
              </p>
              <div
                className="link-btn"
                style={{
                  position: "relative",
                  zIndex: 999,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <span
                  href="#"
                  className="theme-btn faiz py-4"
                  onClick={() => navigate("/broker-reviews")}
                >
                  <span className="faiz1">
                    GET YOUR BROKER <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
